import React from 'react'
import BossDialog from '../../../components/BossDialog';

const TransmissionReportForm = (props) => {
    const { onClose, transmissionReport = {} } = props;
    return (
        <BossDialog
            title={"Transmission Report"}
            onClose={onClose}
            width="650px"
        >
            <div style={{ padding: '8px 0' }}>
                {/* Table */}
                <div style={{
                    maxHeight: '350px',
                    overflowY: 'auto',
                    borderRadius: '8px',
                    border: '1px solid #e5e7eb',
                }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                        <thead>
                            <tr style={{ background: '#f8fafc', position: 'sticky', top: 0, zIndex: 1 }}>
                                <th style={{ padding: '10px 14px', textAlign: 'center', fontWeight: 600, color: '#475569', borderBottom: '2px solid #e2e8f0', width: '70px' }}>Status</th>
                                <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: '#475569', borderBottom: '2px solid #e2e8f0' }}>Title</th>
                                <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: '#475569', borderBottom: '2px solid #e2e8f0' }}>Node</th>
                                <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: '#475569', borderBottom: '2px solid #e2e8f0' }}>Message</th>
                            </tr>
                        </thead>
                        <tbody>
                            {transmissionReport.items?.map((item, idx) => (
                                <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9', background: idx % 2 === 0 ? '#fff' : '#fafbfc' }}>
                                    <td style={{ padding: '10px 14px', textAlign: 'center' }}>
                                        {item.status === 'success'
                                            ? <i className="fa fa-check-circle" style={{ color: '#16a34a', fontSize: '15px' }} />
                                            : <i className="fa fa-times-circle" style={{ color: '#dc2626', fontSize: '15px' }} />
                                        }
                                    </td>
                                    <td style={{ padding: '10px 14px', fontWeight: 500, color: '#1e293b' }}>{item.Title}</td>
                                    <td style={{ padding: '10px 14px', color: '#64748b' }}>{item.node}</td>
                                    <td style={{ padding: '10px 14px', color: item.status === 'success' ? '#16a34a' : '#ef4444', fontWeight: 500 }}>{item.message}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Footer summary */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    gap: '20px',
                    marginTop: '16px',
                    padding: '10px 14px',
                    background: '#f8fafc',
                    borderRadius: '8px',
                    fontSize: '13px',
                    color: '#64748b'
                }}>
                    <span><i className="fa fa-check-circle" style={{ color: '#16a34a', marginRight: '6px' }} />Created: <strong style={{ color: '#16a34a' }}>{transmissionReport.successCount || 0}</strong></span>
                    <span><i className="fa fa-times-circle" style={{ color: '#dc2626', marginRight: '6px' }} />Failed: <strong style={{ color: '#dc2626' }}>{transmissionReport.failedCount || 0}</strong></span>
                </div>
            </div>
        </BossDialog>
    )
}

export default TransmissionReportForm